import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Col, FormGroup, Label, Row, Form, Button } from 'reactstrap'
import useAddProducts from '../Hooks/useAddProducts';
import { useQueryClient } from '@tanstack/react-query';
import useUpdateProduct from '../Hooks/useUpdateProduct';

const AddEditForm = ({isEditMode,productData,onClose}) => {

    const queryClient = useQueryClient();

     // custom hook for adding product
    const{isAdding,isAdded,addProduct} = useAddProducts();
    // hook for updating product
    const{isUpdating,isUpdated,updateProduct} = useUpdateProduct();

    const{register,handleSubmit,formState:{errors,isSubmitting},reset} = useForm({
        defaultValues:{
            productName: "",
            defaultPrice:""
        },
        criteriaMode:"all",
        mode: "onChange"
    });

    // when editing,populate from existing data
    useEffect(()=>{
        if(isEditMode && productData){
            const formValues ={
                productName : productData.product_name,
                defaultPrice : productData.default_price
            };

            reset(formValues);
        }else{
            reset();
        }
    },[isEditMode,productData,reset])

    const onSubmit =async(data)=>{
        const payload = {
            product_name: data.productName,
            default_price : data.defaultPrice,

            ...(isEditMode && {id:productData.id})
        }
        
        if(isEditMode){
            updateProduct(payload,{
                onSuccess:(updatedProduct)=>{
                    onClose();
                    queryClient.setQueryData(
                      ['initialData'],
                      (old)=> ({
                        ...old,
                        products: old.products.map(
                          product=> product.id === updatedProduct.id ? updatedProduct : product
                        )
                      })
                    )
                }
            })
        }else{
            addProduct(payload,{
                onSuccess:(newProduct)=>{
                    onClose();
                    queryClient.setQueryData(
                      ['initialData'],
                      (old) => ({
                        ...old,
                        products: [...old.products || [],newProduct]
                      })
                    )
                    
                }
            })
        }
    }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-4">
      {/* Form Group */}
      
        <Row>
          <Col>
            <FormGroup>
              <div className="mb-3">
                <label htmlFor="productName" className="form-label fw-500">
                  Product Name
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.productName ? 'is-invalid' : ''}`}
                  id="productName"
                  placeholder="Enter product name"
                  autoFocus
                  {...register("productName", {
                    required: "Product Name is required",
                    minLength: {
                      value: 2,
                      message: "Product name must be at least 2 characters"
                    },
                    pattern: {
                      value: /^[A-Za-z\s\-]+$/,
                      message: "Only letters,spaces and hyphens are allowed"
                    }
                  })}
                />
                {errors.productName && (
                  <div className="invalid-feedback d-block">
                    {errors.productName.message}
                  </div>
                )}
              </div>
            </FormGroup>
          </Col>
          <Col>
              <FormGroup>
                <div className="mb-3">
                <label htmlFor="defaultPrice" className="form-label fw-500">
                  Default Price
                </label>
                <input
                  type="number"
                  min={0}
                  className={`form-control ${errors.defaultPrice ? 'is-invalid' : ''}`}
                  id="defaultPrice"
                  placeholder="Enter Price"
                  autoFocus
                  {...register("defaultPrice", {
                    required: "Price is required",
                  valueAsNumber:true})}
                />
                {errors.defaultPrice && (
                  <div className="invalid-feedback d-block">
                    {errors.defaultPrice.message}
                  </div>
                )}
              </div>
              </FormGroup>
          </Col>
        </Row>
        
        <Row className="justify-content-center mt-3">
          <Col xs="auto">
            <Button
              type="reset"
              color="secondary"
              outline
              style={{
                fontWeight:"600",
                border:"none"
              }}
              onClick={() => reset()}
              disabled={isAdding || isUpdating}
            >
              Clear
            </Button>
            <Button
              type="submit"
              style={{
                backgroundColor: "#00ADF0",
                color: "white",
                fontWeight: "600",
                border: "none"
              }}
              disabled={isAdding || isUpdating}
            >
              {isEditMode ? 'Update' : 'Add'}
            </Button>
          </Col>
        </Row>
      {/* Action Button */}
      {/* <div className="d-flex justify-content-end gap-2">
        <Button
          type="reset"
          color="secondary"
          outline
          style={{
            fontWeight:"600",
            border:"none"
          }}
          onClick={() => reset()}
        >
          Clear
        </Button>
        <Button
          type="submit"
          style={{
            backgroundColor: "#00ADF0",
            color: "white",
            fontWeight: "600",
            border: "none"
          }}
          disabled={isSubmitting}
        >
          add
        </Button>
      </div> */}
    </form>
  )
}

export default AddEditForm
